import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const BreadcrumbsContainer = styled.div`
  width: 100%;
`;

const BreadcrumbsHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;

  ${media.md`
    padding: 0 20px;
  `}
`;

const BreadcrumbsTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  h2 {
    font-family: ${({ theme }) => theme.headerFont};
    font-size: 35px;
    font-weight: ${({ theme }) => theme.fontWeights.normal};
  }
`;

export const Crumb = ({ children }) => <div>{children}</div>;

Crumb.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

const Breadcrumbs = ({ activeIndex, children }) => (
  <BreadcrumbsContainer>
    <BreadcrumbsHeader>
      <BreadcrumbsTitle id="breadcrumbs-title-item" />
    </BreadcrumbsHeader>
    <div>{React.Children.toArray(children)[activeIndex]}</div>
  </BreadcrumbsContainer>
);

Breadcrumbs.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default Breadcrumbs;
